<template>
    <div class="comment-card">
        <div class="comment-card__image icon icon--size-big">
            <img class="comment-card__image-pic" :src="imageSrc" alt="Иконка карточки">
        </div>
        <div class="comment-card__description">
            <h3 class="comment-card__title">{{ title }}</h3>
            <p class="comment-card__subtitle"><strong>{{ subtitle }}</strong></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommentCard',
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        imageName: {
            type: String,
            required: true
        },
    },
    computed: {
        imageSrc() {
            return require(`@/assets/images/${this.imageName}.png`);
        }
    }
}
</script>

<style scoped lang="scss">
.comment-card {
    $width-desktop: 308px;
    $width-desktop-min: 217px;
    $width-mobile: 173px;

    display: flex;
    align-items: center;

    width: rem($width-desktop);
    padding: rem($gap-normal) rem($gap-medium);

    border-radius: rem($border-radius-default);
    background-color: rgba($white, 0.25);

    box-shadow: $box-shadow-colored;

    @media #{$screen-big} {
        width: rem($width-desktop-min);
    }

    @media (#{$screen-small}) {
        width: rem($width-mobile);
        padding: rem($gap-small) rem($gap-normal);
    }

    &__image {
        flex-shrink: 0;
        
        &-pic {
            @include object-contain-full;
        }
    }

    &__description {
        margin-left: rem($gap-normal);

        @media (#{$screen-small}) {
            margin-left: rem($gap-normal);
        }
    }

    &__title {
        @include text-normal($font-weight-regular, $line-height-medium);

        word-break: break-all;

        color: $color-text-weekened-low;

        @media #{$screen-big} {
            font-size: rem($font-size-mini);
        }

        @media (#{$screen-small}) {
            font-size: rem($font-size-micro);
        }
    }

    &__subtitle {
        @include text-large($font-weight-bold, $line-height-medium);

        margin-top: rem($gap-tiny);

        word-break: break-all;

        color: $primary-weekened;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }

        @media (#{$screen-small}) {
            font-size: rem($font-size-mini);
        }
    }
}
</style>